import type { Definition } from '~/types'
import imageSizes from '../../constants/imageSizes'

export const PagePaymentLookup: Definition = {
  contentType: 'PagePaymentLookup',
  fields: [
    {
      id: 'contentBlock1Title',
      name: 'Content Block 1 Title',
      type: 'Symbol'
    },
    {
      id: 'contentBlock1Text',
      name: 'Content Block 1 Text',
      type: 'RichText'
    },
    {
      id: 'contentBlock1Link',
      name: 'Content Block 1 Link',
      type: 'ModuleNavigationLink'
    },
    {
      id: 'contentBlock2Title',
      name: 'Content Block 2 Title',
      type: 'Symbol'
    },
    {
      id: 'contentBlock2Image',
      name: 'Content Block 2 Image',
      type: 'ModuleMedia',
      imageOptions: { sizes: imageSizes.columns6_169, lazy: true }
    },
    {
      id: 'formTitle',
      name: 'Form Title',
      type: 'Symbol',
      defaultValue: {
        en: 'If you’re not sure who requested the charge, use our ‘look up charge’ tool'
      }
    },
    {
      id: 'faqSectionTitle',
      name: 'FAQ Section Title',
      type: 'Symbol',
      defaultValue: {
        en: 'Frequently asked questions'
      }
    },
    {
      id: 'faqBlock1',
      name: 'FAQ block 1',
      type: 'BlockFaqGroup'
    },
    {
      id: 'faqBlock2',
      name: 'FAQ block 2',
      type: 'BlockFaqGroup'
    },
    {
      id: 'resultSuccessTitle',
      name: 'Result Success title',
      type: 'Symbol',
      defaultValue: {
        en: 'We found your payment'
      }
    },
    {
      id: 'resultSuccessSubtitle',
      name: 'Result Success subtitle',
      type: 'Symbol',
      defaultValue: {
        en: 'This payment was done by {name}. Here are the transaction details:'
      }
    },
    {
      id: 'resultSuccessAuthorizationDateTitle',
      name: 'Result Success authorization date title',
      type: 'Symbol',
      defaultValue: {
        en: 'Authorization date'
      }
    },
    {
      id: 'resultSuccessShopperUrlText',
      name: 'Result Success Shopper url text',
      type: 'Text',
      defaultValue: {
        en: 'In case you have any further questions, we suggest you contact the merchant directly:'
      }
    },
    {
      id: 'resultSuccessIndiatext',
      name: 'Result Success India text',
      type: 'RichText'
    },
    {
      id: 'resultPaymentNotFoundTitle',
      name: 'Result Payment not found title',
      type: 'Symbol',
      defaultValue: {
        en: 'We can’t find this payment'
      }
    },
    {
      id: 'resultPaymentNotFoundMessage',
      name: 'Result Payment not found message',
      type: 'Text',
      defaultValue: {
        en: 'The information provided doesn’t match a transaction we’ve processed. Please double check you filled in the right information or reach out to your bank.'
      }
    },
    {
      id: 'resultApiErrorTitle',
      name: 'Result API Error title',
      type: 'Symbol',
      defaultValue: {
        en: 'Validation error'
      }
    },
    {
      id: 'labelCurrency',
      name: 'Label Currency',
      type: 'Symbol',
      defaultValue: {
        en: 'Currency'
      }
    },
    {
      id: 'labelReferenceType',
      name: 'Label Reference Type',
      type: 'Symbol',
      defaultValue: {
        en: 'Choose lookup method'
      }
    },
    {
      id: 'labelTxDate',
      name: 'Label Tx Date',
      type: 'Symbol',
      defaultValue: {
        en: 'Transaction date (DD-MM-YYYY)'
      }
    },
    {
      id: 'labelAmountCents',
      name: 'Label Amount Cents',
      type: 'Symbol',
      defaultValue: {
        en: 'Amount'
      }
    },
    {
      id: 'labelTypeReference',
      name: 'Label Type Reference',
      type: 'Symbol',
      defaultValue: {
        en: 'PSP reference'
      }
    },
    {
      id: 'labelTypeCard',
      name: 'Label Type Card',
      type: 'Symbol',
      defaultValue: {
        en: 'Last 4 digits'
      }
    },
    {
      id: 'labelTypeCardBin',
      name: 'Label Type Card Bin',
      type: 'Symbol',
      defaultValue: {
        en: 'First 6 digits'
      }
    },
    {
      id: 'labelTypeIban',
      name: 'Label Type IBAN',
      type: 'Symbol',
      defaultValue: {
        en: 'IBAN'
      }
    },
    {
      id: 'labelCountry',
      name: 'Label Country',
      type: 'Symbol',
      defaultValue: {
        en: 'Country'
      }
    },
    {
      id: 'labelEmail',
      name: 'Label Email',
      type: 'Symbol',
      defaultValue: {
        en: 'Email'
      }
    },
    {
      id: 'labelUpiTransactionId',
      name: 'Label UPI Transaction ID',
      type: 'Symbol',
      defaultValue: {
        en: 'UPI Transaction ID'
      }
    },
    {
      id: 'explanationReference',
      name: 'Explanation Reference',
      type: 'Symbol',
      defaultValue: {
        en: 'A PSP is a unique 16-character reference linked to a specific payment transaction. It is often reflected on the transaction’s bank statement under ‘payment details’'
      }
    },
    {
      id: 'explanationCard',
      name: 'Explanation Card',
      type: 'Symbol',
      defaultValue: {
        en: 'Please provide only the last 4 digits of the card used for this transaction'
      }
    },
    {
      id: 'cardBinExplanation',
      name: 'Card Bin Explanation',
      type: 'Symbol',
      defaultValue: {
        en: 'Please provide only the first 6 digits of the card used for this transaction'
      }
    },
    {
      id: 'explanationIban',
      name: 'Explanation IBAN',
      type: 'Symbol',
      defaultValue: {
        en: 'The IBAN (International Bank Account Number) serves as the unique identifier for a bank account on an international level, often used for  SEPA payments.'
      }
    },
    {
      id: 'explanationEmail',
      name: 'Explanation Email',
      type: 'Symbol',
      defaultValue: {
        en: 'Shopper Email'
      }
    },
    {
      id: 'explanationUpiTransactionId',
      name: 'Explanation UPI Transaction ID',
      type: 'Symbol',
      defaultValue: {
        en: 'UPI Transaction ID'
      }
    },
    {
      id: 'errorMessage',
      name: 'Error Message',
      type: 'Symbol',
      defaultValue: {
        en: 'Required field'
      }
    },
    {
      id: 'errorMessageTxDate',
      name: 'Error Message Tx Date',
      type: 'Symbol',
      defaultValue: {
        en: 'Please enter a date in the following format DD-MM-YYYY'
      }
    },
    {
      id: 'errorMessageAmountCents',
      name: 'Error Message Amount Cents',
      type: 'Symbol',
      defaultValue: {
        en: 'Please enter a valid amount number'
      }
    },
    {
      id: 'errorMessageTypeReference',
      name: 'Error Message Type Reference',
      type: 'Symbol',
      defaultValue: {
        en: 'Please enter 16 digits'
      }
    },
    {
      id: 'errorMessageTypeCard',
      name: 'Error Message Type Card',
      type: 'Symbol',
      defaultValue: {
        en: 'Please enter 4 digits'
      }
    },
    {
      id: 'errorMessageTypeIban',
      name: 'Error Message Type IBAN',
      type: 'Symbol',
      defaultValue: {
        en: 'Please enter a valid IBAN'
      }
    },
    {
      id: 'errorMessageCardBin',
      name: 'Error Message Card Bin',
      type: 'Symbol',
      defaultValue: {
        en: 'Please enter 6 digits'
      }
    },
    {
      id: 'errorMessageEmail',
      name: 'Error Message Email',
      type: 'Symbol',
      defaultValue: {
        en: 'Please enter a valid email address example@domain.com'
      }
    },
    {
      id: 'errorMessageUpiTransactionId',
      name: 'Error Message UPI Transaction ID',
      type: 'Symbol',
      defaultValue: {
        en: 'Please enter a valid UPI transaction ID'
      }
    },
    {
      id: 'submitButton',
      name: 'Submit Button',
      type: 'Symbol',
      defaultValue: {
        en: 'Look up'
      }
    }
  ]
}

export default {
  PagePaymentLookup
}
